import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import constants from "../../assets/constants.js";
import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import BotpressBotStatus from "../widgets/botpressBotStatus";
import BotpressBotUseage from "../widgets/botpressBotUseage";

const BotpressClientPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Client Portal" />
      <PortalGridContent>
        <Grid size={{ xs: 12, lg: 3 }}>
          <BotpressBotStatus />
        </Grid>
        <Grid size={{ xs: 12, lg: 9 }}>
          <BotpressBotUseage botpressGraphType={constants.botpressGraphTypes.usersGraph} />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <BotpressBotUseage
            botpressGraphType={constants.botpressGraphTypes.messagesGraph}
            colorIndex={2}
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <BotpressBotUseage
            botpressGraphType={constants.botpressGraphTypes.sessionsGraph}
            colorIndex={4}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }} />
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressClientPortal);
